<template>
<div class="chapter">
<div class="inner_page">
<p class="C126"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="C139"><a id="page_v"><em></em></a><em><a href="#/xhtml/04_List_of#page_vii">List of Illustrations</a></em></p>
<p class="C136"><em><a href="#/xhtml/05_Acknowle#page_ix">Acknowledgments</a></em></p>
<p class="C139"><a href="#/xhtml/06_Introduc#page_1">Introduction</a></p>
<p class="C139"><a href="#/xhtml/07_1__In_Pu#page_14"><strong>1.</strong> In Pursuit of the Good Project</a></p>
<p class="C139"><span href="#/xhtml/08_2__Benef#page_39" title="Link target outside of Sample"><strong>2.</strong> Beneficiaries as a Commodity</span></p>
<p class="C139"><span href="#/xhtml/09_3__The_L#page_70" title="Link target outside of Sample"><strong>3.</strong> The Logframe and the History of the Market for Projects</span></p>
<p class="C139"><span href="#/xhtml/10_4__The_H#page_92" title="Link target outside of Sample"><strong>4.</strong> The History of Humanitarian Authority and the Divisions of the Humanitarian Field</span></p>
<p class="C139"><span href="#/xhtml/11_5__The_R#page_126" title="Link target outside of Sample"><strong>5.</strong> The Reform of Humanitarianism</span></p>
<p class="C139"><span href="#/xhtml/12_6__What#page_147" title="Link target outside of Sample"><strong>6.</strong> What about Human Rights?</span></p>
<p class="C136"><span href="#/xhtml/13_Conclusi#page_168" title="Link target outside of Sample">Conclusion</span></p>
<p class="C139"><em><span href="#/xhtml/14_Appendix#page_177" title="Link target outside of Sample">Appendix on Methods</span></em></p>
<p class="C139"><em><span href="#/xhtml/15_Bibliogr#page_183" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C139"><em><span href="#/xhtml/16_Notes" title="Link target outside of Sample">Notes</span></em></p>
<p class="C139"><em><span href="#/xhtml/17_Index#page_209" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?11a3b06c